import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { LinkOutlined } from "@ant-design/icons";

const CopyComponent = ({ buttonText, afterCopiedPropmpt, copyText }) => {
  const [showCopiedModal, setShowCopiedModal] = useState(false);
  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setShowCopiedModal(true);
        setTimeout(() => {
          setShowCopiedModal(false);
        }, 500);
      })
      .catch((error) => {
        console.error("Failed to copy text to clipboard:", error);
      });
  };
  return (
    <>
      <Modal show={showCopiedModal} onHide={() => setShowCopiedModal(false)}>
        <Modal.Body>
          <span style={{ width: "5rem" }}>{afterCopiedPropmpt}</span>
        </Modal.Body>
      </Modal>
      <Button style={{ height: "2.5rem" }} onClick={() => handleCopy(copyText)}>
        <span className="pe-1 text-truncate">
          {buttonText} <span className="ms-1">{<LinkOutlined />}</span>
        </span>
      </Button>
    </>
  );
};

export default CopyComponent;
